import { render } from "./UploadCategory.vue?vue&type=template&id=38196b1a&scoped=true"
import script from "./UploadCategory.vue?vue&type=script&lang=js"
export * from "./UploadCategory.vue?vue&type=script&lang=js"

import "./UploadCategory.vue?vue&type=style&index=0&id=38196b1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38196b1a"]])

export default __exports__